// editorStores.js
import { atom, map } from 'nanostores';

export const SYM_STORES = Symbol.for('vz.editor.stores');
export const SYM_OPEN = Symbol.for('vz.editor.openNodeMenu');
export const SYM_CLOSE = Symbol.for('vz.editor.closeNodeMenu');

function createStores() {
  const activeBlockKey = atom(null);
  const selectedBlockKeys = atom([]);
  const nodeMenu = map({
    isOpen: false,
    activeKey: null,
    anchorRect: null,
    customNodeControls: [],
    disabledNodeControls: []
  });
  const nodeRootByKey = new Map(); // non-reactive DOM refs

  function openNodeMenu({ key, getPath, anchorRect, nodeRoot, customNodeControls = [], disabledNodeControls = [] }) {
    activeBlockKey.set(key || null);
    if (nodeRoot) nodeRootByKey.set(key, nodeRoot);
    nodeMenu.set({
      isOpen: true,
      activeKey: key || null,
      getPath,
      anchorRect: anchorRect ? { ...anchorRect } : null,
      customNodeControls,
      disabledNodeControls
    });
  }

  function closeNodeMenu() {
    const { activeKey } = nodeMenu.get();
    if (activeKey) nodeRootByKey.delete(activeKey);
    nodeMenu.set({
      isOpen: false,
      activeKey: null,
      anchorRect: null,
      customNodeControls: [],
      disabledNodeControls: []
    });
  }

  return { activeBlockKey, selectedBlockKeys, nodeMenu, nodeRootByKey, openNodeMenu, closeNodeMenu };
}

export function ensureEditorStores(editor) {
  if (!editor[SYM_STORES]) {
    const stores = createStores();
    editor[SYM_STORES] = stores;
    editor[SYM_OPEN] = stores.openNodeMenu;
    editor[SYM_CLOSE] = stores.closeNodeMenu;
  }
  return editor[SYM_STORES];
}

export function disposeEditorStores(editor) {
  const s = editor[SYM_STORES];
  if (!s) return;

  // reset reactive state
  s.activeBlockKey.set(null);
  s.selectedBlockKeys.set([]);
  s.nodeMenu.set({
    isOpen: false,
    activeKey: null,
    anchorRect: null,
    customNodeControls: [],
    disabledNodeControls: []
  });

  // drop non-reactive refs
  s.nodeRootByKey.clear();

  // detach methods + stores from the editor
  delete editor[SYM_OPEN];
  delete editor[SYM_CLOSE];
  delete editor[SYM_STORES];
}

export function keyFromPath(path) {
  return Array.isArray(path) ? path.join('.') : String(path || '');
}